<template>
  <div>
    <a-card style="margin: 20px" title="商户协议详情">
      <template #extra>
        <a-button @click="goBack">返回</a-button>
      </template>

      <a-spin :spinning="loading">
        <div class="detailBox">
          <!-- 基本信息 -->
          <a-descriptions :column="2" bordered size="small">
            <a-descriptions-item label="商户协议编号">{{ detail.merchantNo || '-' }}</a-descriptions-item>
            <a-descriptions-item label="商户协议名称">{{ detail.merchantName || '-' }}</a-descriptions-item>
            <a-descriptions-item label="状态">
              <a-tag :color="getDictColor(statusDict, detail.status)">{{ getDictLabel(statusDict, detail.status) }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="付款方">
              <WalletInfo v-if="detail.payerAccount" :account-name="detail.payerName" :account-no="detail.payerAccount" :show-account-name="true"/>
              <span v-else>-</span>
            </a-descriptions-item>
            <a-descriptions-item label="收款账户">
              <WalletInfo v-if="detail.payeeAccount" :account-name="detail.payeeName" :account-no="detail.payeeAccount" :show-account-name="true"/>
              <span v-else>-</span>
            </a-descriptions-item>
<!--            <a-descriptions-item label="收款行号">{{ detail.payeeBankNo || '-' }}</a-descriptions-item>-->
<!--            <a-descriptions-item label="收款行名">{{ detail.payeeBankName || '-' }}</a-descriptions-item>-->
            <a-descriptions-item label="默认支付摘要">{{ detail.defaultPaySummary || '-' }}</a-descriptions-item>
            <a-descriptions-item label="审批时间">{{ detail.approvalTime || '-' }}</a-descriptions-item>
            <a-descriptions-item label="审批意见">{{ detail.approvalOpinion || '-' }}</a-descriptions-item>
<!--            <a-descriptions-item label="创建时间">{{ detail.createTime || '-' }}</a-descriptions-item>-->
<!--            <a-descriptions-item label="创建人">{{ detail.creater || '-' }}</a-descriptions-item>-->
            <a-descriptions-item :span="2" label="备注">{{ detail.remark || '-' }}</a-descriptions-item>
          </a-descriptions>

          <!-- 服务费规则 -->
          <a-divider>服务费规则</a-divider>
          <a-table
              :columns="feeRuleColumns"
              :data-source="detail.feeRules || []"
              :pagination="false"
              row-key="ruleId"
              size="small"
          >
            <template slot="feeAccount" slot-scope="text, record">
              <WalletInfo
                  v-if="record.feeAccount"
                  :account-name="record.feeName"
                  :account-no="record.feeAccount"
                  :bank-name="record.feeBankName"
                  :bank-no="record.feeBankNo"
                  :is-wallet="isSystemWallet(record.feeBankNo)"
                  :show-account-name="true"
                  :show-balance="false"
              />
              <span v-else>-</span>
            </template>
            <template slot="feeType" slot-scope="text">
              {{ getDictLabel(payAgrDict.feeType, text) }}
            </template>
            <template slot="feeValue" slot-scope="text, record">
              <span v-if="record.feeType === 1">{{ text }}%</span>
              <span v-else>{{ text }} 元</span>
            </template>
            <template slot="status" slot-scope="text">
              <a-tag :color="getDictColor(payAgrDict.feeRuleStatus, text)">{{ getDictLabel(payAgrDict.feeRuleStatus, text) }}</a-tag>
            </template>
          </a-table>

          <!-- 推送结果 -->
          <a-divider>协议推送结果</a-divider>
          <div v-if="detail.pushTime" style="margin-bottom: 8px; color: #666;">
            最近推送时间：{{ detail.pushTime }}
            <a-tag :color="pushResult && pushResult.allSuccess ? '#52c41a' : '#ff4d4f'" style="margin-left: 8px;">
              {{ pushResult && pushResult.allSuccess ? '全部推送成功' : '存在失败项' }}
            </a-tag>
          </div>
          <template v-if="pushResult">
            <div v-if="pushResult.payContract" style="margin-bottom: 12px;">
              <b>支付协议</b>
              <a-descriptions :column="2" bordered size="small" style="margin-top: 8px;">
                <a-descriptions-item label="协议记录ID">{{ pushResult.payContract.busiPayContractId || '-' }}</a-descriptions-item>
                <a-descriptions-item label="银行协议编号">{{ pushResult.payContract.fileNo || '-' }}</a-descriptions-item>
                <a-descriptions-item label="是否同步">
                  <a-tag :color="pushResult.payContract.synch === '1' ? 'green' : 'orange'">
                    {{ pushResult.payContract.synch === '1' ? '已同步' : '未同步' }}
                  </a-tag>
                </a-descriptions-item>
                <a-descriptions-item label="审批状态">
                  <a-tag :color="checkStatusColor(pushResult.payContract.checkStatus)">
                    {{ payCheckStatusLabel(pushResult.payContract.checkStatus) }}
                  </a-tag>
                </a-descriptions-item>
                <a-descriptions-item :span="2" label="失败原因">{{ pushResult.payContract.failMsg || '-' }}</a-descriptions-item>
              </a-descriptions>
            </div>
            <div v-if="pushResult.withholdContracts && pushResult.withholdContracts.length">
              <b>代扣协议</b>
              <a-table
                  :columns="withholdColumns"
                  :data-source="pushResult.withholdContracts"
                  :pagination="false"
                  :row-key="(record, index) => index"
                  size="small"
                  style="margin-top: 8px;"
              >
                <template slot="withholdFeeAccount" slot-scope="text, record">
                  <WalletInfo
                      v-if="record.feeAccount"
                      :account-name="record.feeName"
                      :account-no="record.feeAccount"
                      :bank-name="record.feeBankName"
                      :bank-no="record.feeBankNo"
                      :is-wallet="isSystemWallet(record.feeBankNo)"
                      :show-account-name="true"
                      :show-balance="false"
                  />
                  <span v-else>-</span>
                </template>
                <template slot="checkStatus" slot-scope="text">
                  <a-tag :color="checkStatusColor(text)">{{ withholdCheckStatusLabel(text) }}</a-tag>
                </template>
              </a-table>
            </div>
          </template>
          <a-empty v-else description="尚未推送"/>

          <!-- 关联订单统计 -->
          <a-divider>关联订单统计</a-divider>
          <a-row :gutter="16" v-if="detail.orderStat">
            <a-col :span="8">
              <a-statistic title="总订单数" :value="detail.orderStat.totalOrders || 0"/>
            </a-col>
            <a-col :span="8">
              <a-statistic title="成功订单数" :value="detail.orderStat.successOrders || 0" :value-style="{color: '#52c41a'}"/>
            </a-col>
            <a-col :span="8">
              <a-statistic title="失败订单数" :value="detail.orderStat.failOrders || 0" :value-style="{color: '#ff4d4f'}"/>
            </a-col>
          </a-row>
        </div>
      </a-spin>
    </a-card>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import {payAgrDict, getDictLabel, getDictColor} from "@/utils/bizDict/payAgrDict";

const statusDict = {...payAgrDict.configStatus};
delete statusDict.default;

export default {
  name: 'PayAgrMerchantConfigDetail',
  components: {WalletInfo},
  data() {
    return {
      payAgrDict,
      statusDict,
      loading: false,
      detail: {},
      feeRuleColumns: [
        {title: '排序', dataIndex: 'sortOrder', align: 'center', width: 60},
        {title: '收款账户', dataIndex: 'feeAccount', align: 'center', scopedSlots: {customRender: 'feeAccount'}},
        // {title: '收款行号', dataIndex: 'feeBankNo', align: 'center'},
        // {title: '收款行名', dataIndex: 'feeBankName', align: 'center'},
        {title: '类型', dataIndex: 'feeType', align: 'center', width: 90, scopedSlots: {customRender: 'feeType'}},
        {title: '费率/金额', dataIndex: 'feeValue', align: 'center', width: 100, scopedSlots: {customRender: 'feeValue'}},
        {title: '摘要', dataIndex: 'feeSummary', align: 'center', customRender: (text) => text || '-'},
        {title: '状态', dataIndex: 'status', align: 'center', width: 80, scopedSlots: {customRender: 'status'}},
      ],
      withholdColumns: [
        {title: '规则ID', dataIndex: 'ruleId', align: 'center', width: 80},
        {title: '收款账户', dataIndex: 'feeAccount', align: 'center', scopedSlots: {customRender: 'withholdFeeAccount'}},
        {title: '协议记录ID', dataIndex: 'busiPayWithholdContractId', align: 'center', width: 100},
        {title: '银行协议编号', dataIndex: 'fileNo', align: 'center', customRender: (text) => text || '-'},
        {title: '审批状态', dataIndex: 'checkStatus', align: 'center', width: 110, scopedSlots: {customRender: 'checkStatus'}},
        {title: '失败原因', dataIndex: 'failMsg', align: 'center', customRender: (text) => text || '-'},
      ],
    };
  },
  computed: {
    pushResult() {
      return this.detail.pushResult || null;
    },
  },
  mounted() {
    const configId = this.$route.query.configId;
    if (configId) {
      this.loadDetail(configId);
    } else {
      message.warning('缺少配置ID参数');
    }
  },
  methods: {
    getDictLabel,
    getDictColor,

    async loadDetail(configId) {
      this.loading = true;
      try {
        const res = await this.api.getPayAgrConfigDetail(configId);
        if (res.code === 200 && res.data) {
          this.detail = res.data;
        } else {
          message.warning(res.info || '获取详情失败');
        }
      } catch (error) {
        console.error('获取详情失败:', error);
        message.error('获取详情失败');
      } finally {
        this.loading = false;
      }
    },

    /** 根据银行行号判断是否为系统内钱包（空行号或本行行号视为系统钱包） */
    isSystemWallet(bankNo) {
      if (!bankNo) return true;
      return bankNo.startsWith('313');
    },

    checkStatusColor(checkStatus) {
      return {'0': 'orange', '1': 'green', '2': 'red', '3': 'red'}[checkStatus] || 'default';
    },

    payCheckStatusLabel(checkStatus) {
      return {'0': '待审批', '1': '通过', '2': '拒绝', '3': '失败'}[checkStatus] || checkStatus || '-';
    },

    withholdCheckStatusLabel(checkStatus) {
      return {'0': '未审批', '1': '已审批（登记成功）', '2': '拒绝', '3': '失败'}[checkStatus] || checkStatus || '-';
    },

    goBack() {
      this.$router.push('/pay-agr/merchantConfig');
    },
  },
};
</script>

<style lang="less" scoped>
.detailBox {
  padding: 10px;
}
</style>
